import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export function equalTrue(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value == true ? null : { equalTrue: true };
  };
}
